import { render } from "./ListaCampoForm.vue?vue&type=template&id=8ac14a86"
import script from "./ListaCampoForm.vue?vue&type=script&lang=ts"
export * from "./ListaCampoForm.vue?vue&type=script&lang=ts"

import "./ListaCampoForm.vue?vue&type=style&index=0&id=8ac14a86&lang=css"
script.render = render

export default script